export const json = { 
    "title": {
      "default": "KHẢO SÁT Ý KIẾN KHÁCH HÀNG VỀ HỆ THỐNG HIP",      
      "en": "RENEWAL HD HYUNDAI VIETNAM INTERNET PROCUREMENT SURVEY QUESTION"
    },
    "description": {
        "default" : "Vui lòng cho chúng tôi biết ý kiến của bạn về hệ thống web báo giá mới của HVS bằng cách trả lời các câu hỏi dưới đây",
        "en" : "Please share us your idea about new HIP system by completing the below question"
    },
    "logo": "http://ibiz.hvs.com.vn/hmd_logo.ico",
    "logoWidth": "60px",
    "logoHeight": "60px",
    "pages": [
     {
      "name": "page1",
      "elements": [
        {
          "type": "panel",
          "name": "makeScore",
          "isRequired": true,
          "elements": [
              {
                  "type": "radiogroup",
                  "name": "hipScore",
                  "title": {
                      "default": "Trong 4 mức dưới đây, bạn đánh giá như thế nào về hệ thống web mới của HVS?",
                      "en": "On 4 below options, how likely are you to evaluate the new HIP system?"
                  },
                  "choices": [
                   {
                      "value": 4,
                      "text":{
                          "default": "Rất tốt",
                          "en": "Extremely good"
                        }
                    }, {
                      "value": 3,
                      "text":{
                        "default": "Tốt",
                        "en": "Good"
                      }
                    }, {
                      "value": 2,
                      "text":{
                        "default": "Không có gì nổi bật",
                        "en": "Neutral (so so)"
                      }
                    }, {
                      "value": 1,
                      "text":{
                        "default": "Không tốt",
                        "en": "Quite bad"
                      }
                    },
                  ]
              }
          ]
        },
        {
            "type": "checkbox",
            "name": "promoteFeatures",
            "visibleIf": "{hipScore} >= 3",
            "title": {
                "default": "Bạn đánh giá cao nhất những tính năng nào sau đây?",
                "en": "Which of the following features do you value the most?"
            },
            "description": {
                "default": "Chọn tối đa 3 đặc tính bạn đánh giá cao nhất",
                "en": "Please select no more than three features."
            },
            "isRequired": true,
            "choices": [
                {
                "value": "performance",
                "text": {
                    "default": "Tính hiệu quả",
                    "en": "Performance"
                    }
                },
                {
                "value": "stability",
                "text": {
                "default": "Tính ổn định",
                "en": "Stability"
                }
                },
                {
                "value": "ui",
                "text": {
                "default": "Giao diện",
                "en": "User interface"
                }
                },
                {
                "value": "functionality",
                "text": {
                    "default": "Đầy đủ chức năng",
                    "en": "Complete functionality"
                }
                },
                {
                "value": "documentation",
                "text": {
                "default": "Tài liệu hướng dẫn (Hướng dẫn sử dụng, Demos)",
                "en": "Learning materials (documentation, demos)"
                }
                },
                {
                "value": "support",
                "text": {
                "default": "Hỗ trợ khách hàng",
                "en": "Quality support",
                }
                }
            ],
            "showOtherItem": true,
            "otherPlaceholder": {
                "default": "Cụ thể...",
                "en": "Please specify..."
            },
            "maxLength": 200,
            "otherText": {
                "default": "Tính năng khác",
                "en": "Other features"
            },
            "colCount": 2,
            "maxSelectedChoices": 3
        },
        {
            "type": "comment",
            "name": "disappointed",
            "isRequired": true,
            "visibleIf": "{hipScore} = 1",
            "title": {
                "default": "Hệ thống mới gây khó khăn cho bạn, chúng tôi nên làm gì?",
                "en": "How did we disappoint you and what can we do to make things right?"
            },
            "maxLength": 300
        },
        {
            "type": "comment",
            "name": "passiveExperience",
            "isRequired": true,
            "visibleIf": "{hipScore} = 2",
            "title": {
                "default": "Theo bạn, chúng tôi nên cải thiện vấn đề gì tốt hơn nữa?",
                "en": "What can we do to make your experience more satisfying?"
            },
            "maxLength": 300
        },
        {
            "type": "panel",
            "name": "comparision",
            "elements": [
                {
                    "type": "radiogroup",
                    "name": "betterOldOne",
                    "isRequired": true,
                    "title": {
                    "default": "Bạn có cho rằng hệ thống mới tốt hơn hệ thống cũ không?",
                    "en": "Do you think the renewal HIP system is better than the old one?",
                    },
                    "choices": [
                        {
                        "value": "yes",
                        "text": {
                            "default": "Có, tốt hơn hệ thống cũ!",
                            "en": "Sure!"
                        }
                        },
                        {
                        "value": "no",
                        "text": {
                            "default": "Không tốt hơn",
                            "en": "No"
                        }
                        }
                    ]
                }
            ]
        }
      ]
      },
    ],
    "completeText":  "Send",
    "completedHtml": "<h3>Thank you for your feedback</h3>",
    "completedHtmlOnCondition": [
        {
         "expression": "{hipScore} < 3 or {better_oldOne} = 'no'",
         "html": {
          "default": "<h3>Chân thành cảm ơn phản hồi của bạn</h3>. <h4>Chúng tôi đánh giá cao tất cả các ý kiến đóng góp từ quý khách hàng.<br> Trong tương lai, Chúng tôi có thể liên hệ với bạn để tìm hiểu thêm về cách chúng tôi có thể cải thiện hơn nữa sản phẩm của mình vượt qua sự mong đợi bạn. </h4>",
          "en": "<h3>Thanks for your feedback!</h3> <h4>We highly value all ideas and suggestions from our customers, whether they're positive or critical. In the future, our team might reach out to you to learn more about how we can further improve our product so that it exceeds your expectations.</h4>",
         }
        },
        {
         "expression": "{hipScore} >= 3 and {hipScore} < 4",
         "html": {
          "default": "<h3>Chân thành cảm ơn phản hồi của bạn</h3>. <h4>Mục tiêu của chúng tối là tạo ra sản phẩm tốt nhất, và ý kiến của khách hàng đóng một vai trò quan trọng giúp chúng tôi xác định được vấn đề cần cải thiện</h4>",
          "en": "<h3>Thanks for your feedback.</h3> <h4>Our goal is to create the best possible product, and your thoughts, ideas, and suggestions play a major role in helping us identify opportunities to improve.</h4>"
         }
        },
        {
         "expression": "{hipScore} = 4",
         "html": {
          "default": "<h3>Chân thành cảm ơn phản hồi của bạn</h3>. <h4>Thật tuyệt vời khi biết được bạn rất hài lòng với sản phẩm của chúng tôi. <br> Phản hồi của bạn giúp chúng tôi tự tin phát triển thêm nhiều sản phẩm mới để mang lại trải nghiệm tốt nhất cho khách hàng.</h4>",
          "en": "<h3>Thanks for your feedback<h3>. <h4>It's great to hear that you're a fan of our product. <br>Your feedback helps us discover new opportunities to improve it and make sure you have the best possible experience.</h4>"
         }
        }
    ],
    "showQuestionNumbers": "off"
  };